import { type AvatarSizes } from '@air/primitive-avatar';

export const getAvatarImageSrc = (url: string | undefined | null, size: AvatarSizes) => {
  if (!url) {
    return;
  }
  return `${url}?q=80&w=${size * 2}&h=${size * 2}`;
};
